import { Box, Heading, SimpleGrid, Text } from '@chakra-ui/react';

const Hero = () => (
  <SimpleGrid
    pt={[16, null, 24]}
    pb={[10, null, 20]}
    columns={[1, null, null, 2]}
  >
    <Box>
      <Heading size='3xl' mb={6}>
        <Box
          as='span'
          bgGradient='linear(to-r, purple.400, cyan.link )'
          bgClip='text'
        >
          Crucible
        </Box>
        , the smart contract wallet.
      </Heading>
      <Text color='gray.300' fontSize='lg'>
        Subscribe to multiple reward programs, store tokens securely, and easily
        transfer your Crucible with its contents. A Crucible adds another layer
        of protection over your standard wallet by giving you more control over
        your assets.
      </Text>
    </Box>
  </SimpleGrid>
);

export default Hero;
